























































































import { Component, Ref, Vue, Emit, Prop, Watch } from 'vue-property-decorator';

@Component
export default class HelloWord extends Vue {
  @Prop(Object) detailInfo;
  detail_or_list = '';
  form: any = {
    name: '123',
  };
}
